import {pickAll} from 'ramda'
import {MetaType} from 'types/Meta'

import {UrlCheckoutParamsType} from '@vio/core/src/utils/url/types/UrlParams'

const metaParams = (params: UrlCheckoutParamsType) =>
  pickAll<UrlCheckoutParamsType, MetaType>(
    ['currency', 'deviceType', 'locale', 'gsite', 'vf'],
    params
  )

export default metaParams
